import {
    STATUS_BADGES,
    STATUS_LABELS,
    TYPE_BADGES,
    TYPE_LABELS,
} from './labels';

const ACTIONS = [
    { status: 'read', label: 'Mark read', className: 'btn-info' },
    { status: 'resolved', label: 'Resolve', className: 'btn-success' },
    { status: 'archived', label: 'Archive', className: 'btn-secondary' },
    { status: 'new', label: 'Reopen', className: 'btn-outline-secondary' },
];

/**
 * props:
 * - data
 * - onClose
 * - onStatusChange (id, status)
 */
function FeedbackModal({ data, onClose, onStatusChange }) {
    const user = data.user || {};

    return (
        <>
            <div
                className="modal fade show d-block"
                tabIndex="-1"
                role="dialog"
                aria-modal="true"
                aria-label={`Feedback ${data.id}`}
            >
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3 className="modal-title h4">
                                Feedback #{data.id}
                            </h3>
                            <button
                                type="button"
                                className="btn-close"
                                aria-label="Close"
                                onClick={onClose}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="row mb-3">
                                <div className="col-md-6 mb-2">
                                    <div className="text-muted small">Type</div>
                                    <span
                                        className={`badge ${TYPE_BADGES[data.type] || 'bg-gray'}`}
                                    >
                                        {TYPE_LABELS[data.type] || data.type}
                                    </span>
                                </div>
                                <div className="col-md-6 mb-2">
                                    <div className="text-muted small">
                                        Status
                                    </div>
                                    <span
                                        className={`badge ${STATUS_BADGES[data.status] || 'bg-gray'}`}
                                    >
                                        {STATUS_LABELS[data.status] ||
                                            data.status}
                                    </span>
                                </div>
                                <div className="col-md-6 mb-2">
                                    <div className="text-muted small">User</div>
                                    {user.name || '-'}
                                    <br />
                                    <small>{user.email}</small>
                                </div>
                                <div className="col-md-6 mb-2">
                                    <div className="text-muted small">
                                        Received
                                    </div>
                                    {new Date(data.createdAt).toLocaleString()}
                                </div>
                                <div className="col-md-12 mb-2">
                                    <div className="text-muted small">Page</div>
                                    {data.page ? (
                                        <a
                                            href={data.page}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            {data.page}
                                        </a>
                                    ) : (
                                        '-'
                                    )}
                                </div>
                                <div className="col-md-12">
                                    <div className="text-muted small">
                                        User agent
                                    </div>
                                    <small className="text-break">
                                        {data.userAgent || '-'}
                                    </small>
                                </div>
                            </div>
                            <hr />
                            <p className="mb-1 fw-bold">Message</p>
                            <div
                                className="border rounded p-3 bg-light"
                                style={{ whiteSpace: 'pre-wrap' }}
                            >
                                {data.message}
                            </div>
                        </div>
                        <div className="modal-footer">
                            {ACTIONS.filter(
                                action => action.status !== data.status,
                            ).map(action => (
                                <button
                                    key={action.status}
                                    type="button"
                                    className={`btn ${action.className}`}
                                    onClick={() =>
                                        onStatusChange(data.id, action.status)
                                    }
                                >
                                    {action.label}
                                </button>
                            ))}
                            <button
                                type="button"
                                className="btn btn-outline-gray-600"
                                onClick={onClose}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>
        </>
    );
}

export default FeedbackModal;
